<template>
  <ve-histogram
    :data="chartData"
    :width="width"
    :height="height"
    :colors="colors"
    :extend="config"
    :tooltip-visible="true"
    :legend-visible="false"
  ></ve-histogram>
</template>

<script>
import VeHistogram from 'v-charts/lib/histogram.common';
import merge from 'merge-dictionaries';
// import { createTooltipContent } from "@/components/charts/config/nanhaiConfig";

function createTooltipContent(params, labelMap, colors) {
  let ret = '<div>';
  const titleContent = params[0] ? params[0].name : `${new Date().getMonth() + 1}.${new Date().getDate()}`;
  const title = `<div style="color: #888888; line-height: 20px">${titleContent}</div>`;
  ret += title;

  params.forEach((parm, index) => {
    const color = colors[index] || '#333';
    const label = parm && parm.seriesName ? labelMap[parm.seriesName] : '';
    const value = parm && parm.value && parm.value[1] ? parm.value[1] : '';
    const row = `<div style="line-height: 20px;"><div style="display:inline-block; vertical-align: middle;background: ${color}; width: 4px; height: 4px; border-radius: 50%; margin-right: 10px "></div><div style="display:inline-block; vertical-align: middle; line-height: 20px; ">${label}:  <span style="color:${color}">${value}</span></div></div>`;
    ret += row;
  });

  ret += '</div>';

  return ret;
}
export default {
  name: 'lungLine',
  components: {
    VeHistogram,
  },
  props: {
    legendMap: {
      type: Object,
      default: () => {},
    },
    data: {
      type: Object,
      default: () => {},
    },
    width: {
      type: String,
      default: `${window.innerWidth * 0.9}px`,
    },
    height: {
      type: String,
      default: `${(window.innerWidth * 0.9 * 10) / 21}px`,
    },
    lang: {
      type: String,
      default: 'en',
    },
    // 配色集
    colors: {
      type: Array,
      default: () => ['#F45253', '#FF961E', '#178B50'],
    },
    // extend config
    extend: {
      type: Object,
      default: () => {},
    },
    isReport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    // function createTooltipContent (params, labelMap, colors) {
    //   let ret = '<div>'
    //   const titleContent = params[0] ? params[0].name : new Date().getMonth() + 1 + '.' + new Date().getDate()
    //   const  title = '<div style="color: #888888; line-height: 20px">' + titleContent + ' 全国疫情</div>'
    //   ret += title

    //   params.forEach(function (parm, index) {
    //     const color = colors[index] || '#333'
    //     const label = (parm && parm.seriesName) ? labelMap[parm.seriesName] : ''
    //     const value = (parm && parm.value && parm.value[1]) ? parm.value[1] : ''
    //     const row = '<div style="line-height: 20px;"><div style="display:inline-block; vertical-align: middle;background: ' + color + '; width: 4px; height: 4px; border-radius: 50%; margin-right: 10px "></div><div style="display:inline-block; vertical-align: middle; line-height: 20px; ">' + label + ':  <span style="color:' + color + '">' + value + '</span></div></div>'
    //     ret += row
    //   })

    //   ret += '</div>'

    //   return ret
    // }

    return {
      config: {
        color: ['#F45253', '#178B50', '#FF961E', '#508EED', '#FFCA00', '#57B8BB'],
        xAxis: {
          axisLabel: {
            fontSize: 9,
          },
        },
        yAxis: {
          minInterval: 1,
          splitLine: {
            lineStyle: {
              color: '#CACACA',
              width: 0.8,
            },
          },
          axisLabel: {
            fontSize: 9,
          },
        },
        legend: {
          show: true,
          icon: 'roundRect',
          itemWidth: 9,
          itemHeight: 9,
          bottom: 0,
          // formatter: name => {
          //   return this.legendMap[name];
          // }
        },
        grid: {
          left: '0%',
          right: '5%',
          bottom: this.lang === 'en' ? '40%' : '30%',
          top: '5%',
          containLabel: true,
        },
        // emphasis: {
        //   itemStyle: {
        //     symbolSize: 1,
        //   },
        //     symbolSize: 1,
        //   // borderColor: '#000'
        // },
        itemStyle: {
          // borderColor: "#fff"
          barWidth: 10, // 柱子宽度
        },
        series: [
          {
            // 柱的信息
            type: 'bar',
            // data: [40, 90],
            barWidth: 10, // 柱子宽度
            // barGap: 1, //柱子之间间距
          },
        ],
        animationDuration: 400,
        // tooltip: {
        //   show: true,
        //   trigger: "axis",
        //   showContent: true,
        //   backgroundColor: "#fff",
        //   textStyle: {
        //     color: "#333",
        //     fontSize: 9,
        //     lineHeight: 20
        //   },
        //   extraCssText:
        //     "border: 1px solid #DFDFDF;box-shadow: 0 2px 14px 0 rgba(0,0,0,0.05);border-radius: 12px; padding: 6px; text-align: left",
        //   formatter: params => {
        //     // console.log('params', params)
        //     const ret = createTooltipContent(params, this.legendMap, this.colors);
        //     return ret;
        //   }
        // },
      },
    };
  },
  computed: {
    chartData() {
      // let chartData = { columns: this.data.columns };

      return {
        color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83'],
        // columns: this.data.columns,
        columns: this.data.columns, // ["Local case", "Probable local", "Imported", "Linked w/ local", "Linked w/ probable local", "Linked w/ imported"],
        rows: this.data
          .rows /* [
            { "Local case": 1200,
              "Probable local": 120,
              "Imported": 1110,
              "Linked w/ local": 1110,
              "Linked w/ probable local": 10,
              "Linked w/ imported": 2100
            }
          ]*/,
      };
    },
  },
  mounted() {
    // this.config = merge(this.config, this.extend);
  },
};
</script>
